require('./bootstrap');

import Vue from 'vue'
import Vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import router from './router/index'
import store from './store/index'
import App from './components/App'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// window.axios.interceptors.request.use(response=>{
//     // console.log('interceptors request response')
//     // if(!store.getters['auth/authenticated']){
//     //     console.log('no authenticated')
//     //     //router.push('/login')
//     // } else {
//     //     console.log('authenticated')
//     // }
//      return response;
// },error => {
//   //  console.log('error')
// })
// window.axios.interceptors.response.use(response=>{
//     return response
//     },
//     function (error) {
//         // if (error.response.status === 401 || error.response.status === 419) {
//         //     router.push('/login')
//         // }
//        //return Promise.reject(error.response);
//     }
// );

// import Echo from 'laravel-echo';
// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: false,
//     wsHost: window.location.hostname,
//     wsPort: process.env.MIX_WEBSOCKET_PORT,
//     enabledTransports: ['ws']
// });

// Vue.component('home', require('./components/Home.vue').default)
// Vue.component('DrawerMenu', require('./components/left-menu/DrawerMenu.vue').default)
Vue.use(VueRouter)
Vue.config.productionTip = false;
Vue.config.devtools = true;
const app = new Vue({
    vuetify: Vuetify,
    router,
    store,
    components: {App},
    el: "#app"
})


